import styled from 'styled-components';
import { makeStyles } from '@material-ui/core/styles';
import { fontFamily } from '@mui/system';

export const Wrapper = styled.div`
display: flex;
flex-direction: column;
align-items: flex-start;
justify-content: flex-start;
gap: 5px;
width: 100%;
height: auto;
.MuiInputBase-input {
    padding: 12px !important;
}
.label {
    font-weight: 500;
    font-size: 12px;
    line-height: 26px;
    color: rgba(69, 69, 69, 1);
	${p => p.dir === 'ltr' && `
		direction: ltr;
	`}	
	span {
		color: red
	}
}
.desc {
    font-size: 11px;
    font-weight: 400;
    color: rgba(145, 145, 145, 1);
    margin: 0 !important;
    margin-top: -10px !important;
}
.error-text {
	font-weight: 500;
    font-size: 12px;
    line-height: 24px;
    color: red;
    @media (max-width: 600px) {
        font-size: 11px;
        line-height: 22px;
    }
}
`

export const useStyles = makeStyles({
	input: {
		border: '1px solid #E5E7EB',
	},
	error: {
		border: '2px solid red !important',
		fontSize: '14px',
		fontWeight: 400,
		borderRadius: '10px',
		'@media (max-width: 600px)': {
			fontSize: '13px',
		},
		'& input::placeholder': {
			fontSize: '16px',
			fontWeight: 400,
			color: '#B2B1B;',
			'@media (max-width: 600px)': {
				fontSize: '15px',
			},
		},
	},
    helperText: {
        boxShadow: 'none !important',
    },
	root: {
		fontSize: '16px',
		fontWeight: 400,
		borderRadius: '10px',
		boxShadow: 'none !important',
        color: '#0D2439',
		fontFamily: 'Samim !important',
		'@media (max-width: 600px)': {
			fontSize: '15px',
		},
        '& p':{
            color: '#61788E',
            fontSize: '12px',
			fontFamily: 'samim',
			marginLeft: '0',
			'@media (max-width: 600px)': {
				fontSize: '11px',
			}
        },
		'& input::placeholder': {
			fontSize: '14px',
			fontWeight: 400,
			color: '#B2B1B3',
			opacity: 1,
			fontFamily: 'Samim !important',
		  },
		  '& .MuiOutlinedInput-root': {
			'&.Mui-focused fieldset': {
			  border: '2px solid #3f51b5 !important',
			},
			'&:hover fieldset': {
                border: '1px solid gray',
            },
		  },
	},
});
